import { useCallback, useEffect, useState } from 'react';

export function usePaginatedList(fetchFn, deps = [], pageSize = 50) {
    const [items, setItems] = useState([]);
    const [total, setTotal] = useState(0);
    const [offset, setOffset] = useState(0);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    const load = useCallback(async () => {
        setLoading(true);
        setError('');
        try {
            const data = await fetchFn({ limit: pageSize, offset });
            setItems(data.items || []);
            setTotal(data.total || 0);
        } catch (err) {
            setError(err.message || 'Ошибка загрузки');
            setItems([]);
            setTotal(0);
        } finally {
            setLoading(false);
        }
    }, [fetchFn, offset, pageSize]);

    useEffect(() => {
        load();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [load, offset, ...deps]);

    const reload = useCallback(() => {
        load();
    }, [load]);

    return {
        items,
        total,
        offset,
        limit: pageSize,
        loading,
        error,
        setOffset,
        reload,
    };
}
